import React, { FC } from "react";
import styles from "./UploadedTablesList.module.css";
import { UploadedTablesQuery } from "src/gql/codegen/graphql";
import cn from "classnames";
import { Badge } from "src/components/ui-components/Badge/Badge";
import { IconGlobe } from "src/components/ui-components/Icons/IconGlobe";
import { IconLockSimple } from "src/components/ui-components/Icons/IconLockSimple";
import { usePaginatedData } from "src/components/ui-components/Table/hooks/usePaginatedData";
import { Table } from "src/components/ui-components/Table";
import { DatasetSettings } from "./DatasetSettings";
import { buildFullName } from "../QueryPage/EditorPageSidebar/SidebarContent/DataExplorerSidebarContent/DataExplorer/Views/CatalogTables/CatalogTable";
import { isNonNullable } from "src/utils/types/types";

type UploadedTablesListProps = {
  uploadedTables: UploadedTablesQuery["uploaded_tables"];
  canEdit: boolean;
};

export const UploadedTablesList: FC<UploadedTablesListProps> = ({
  uploadedTables,
  canEdit,
}) => {
  const {
    setActivePageNumber,
    maxPageNumber,
    activePageNumber,
    paginatedData,
  } = usePaginatedData({
    data: uploadedTables,
  });

  return (
    <Table.Section
      className={styles.table}
      pagination={{
        activePageNumber,
        maxPageNumber,
        onChange: setActivePageNumber,
      }}
    >
      <Table.Head>
        <tr>
          <td>Table Name</td>
          {/*<td>File Name</td>*/}
          <td>Status</td>
          <td />
        </tr>
      </Table.Head>
      <Table.Body>
        {paginatedData.map(({ table_name, status, is_private, created_at }) => {
          const visibilityBadge = is_private ? privateBadge : publicBadge;
          const statusClass = status.match(/available/gi)
            ? styles.statusGreen
            : styles.statusRed;

          let fullName = table_name;
          const [catalogName, schemaName, tableName] = table_name.split(".");
          if (
            isNonNullable(catalogName) &&
            isNonNullable(schemaName) &&
            isNonNullable(tableName)
          ) {
            fullName = buildFullName({
              catalogName,
              schemaName,
              tableName,
            });
          }

          return (
            <tr key={table_name}>
              <td className={styles.tableName}>
                <strong>{fullName}</strong>
                {visibilityBadge}
              </td>
              {/*<td className={styles.truncated}>{file_name}</td>*/}
              <td>
                <div className={cn(styles.status, statusClass)}>
                  {status.toLowerCase()}
                </div>
              </td>
              {canEdit ? (
                <DatasetSettings
                  isPrivate={is_private}
                  tableName={table_name}
                  createdAt={created_at}
                />
              ) : (
                <td />
              )}
            </tr>
          );
        })}
      </Table.Body>
    </Table.Section>
  );
};

const publicBadge = (
  <Badge size="M" color="info" variant="filled">
    <IconGlobe />
    Public
  </Badge>
);

const privateBadge = (
  <Badge size="M" color="warning" variant="filled">
    <IconLockSimple />
    Private
  </Badge>
);
